// extracted by mini-css-extract-plugin
module.exports = {"vpnpricecomparison-inner-body":"layouts_vpnpricecomparison-inner-body__GEXGI","background":"layouts_background__jUKkk","quoto-main-svg":"layouts_quoto-main-svg__A5TNP"};